import { SalesReportService } from "./sales-report.service";
import { CustomSelection, Report, RowActions, SelectionAction } from '../../report';
import paymentOptionsConstant from '../../../../../shared/paymentOptionsConstant';
import { GetSellerInfoService } from '../../services/get-seller-info.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import * as moment from 'moment';
import { ResendMailService } from "../../services/resend-mail.service";
import { UpdateStatusService } from "../../services/update-status.service";
import { AlertDialogComponent } from "../../../../../shared/components/alert-dialog/alert-dialog.component";
import { RefundCreditPaymentService } from "src/app/shared/services/refund-creditcard-payment.service";
import Swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { CurrentSessionService } from "src/app/shared/services/current-session.service";
import { AmanRefundInquiryService } from "src/app/shared/services/aman-refund-inquiry.service";
import { ContactSendOTPService } from "src/app/public-website/buyer/services/contact-send-otp.service";

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss']
})
export class SalesComponent implements OnInit {
  tableColumns: string[] = [
    "productName",
    //  "subProductName",
    "paymentMethod",
    // "productPrice",
    "ProductType",
    "status",
    "Quantity",
    "amount",
    "merchantRefNumber",
    "promocodeTitle",
    "refNumber",
    "buyerName",
    "buyerEmail",
    "buyerMobile",
    "dateStr",
    "BusinessName",
    "reason",
    "createdBy",
    "referralCode"
  ];
  LinkingCoulmns = {
    productName: {
      base: `${window.origin}/`,
      varName: 'code'
    },
    BusinessName: {
      base: `${window.origin}/admin/actions/crm/profile/`,
      varName: 'BusinessId'
    }
  }
  displayTableColumns = {
    productName: "Product",
    //  subProductName: "Sub Product",
    paymentMethod: "Payment Method",
    ProductType: "Product Type",
    //  productPrice: "Price",
    status: "Status",
    Quantity: "Quantity",
    amount: "Amount",
    merchantRefNumber: "Merchant Ref Number",
    promocodeTitle: "Promocode Title",
    refNumber: " Ref Number",
    buyerName: "Buyer Name",
    buyerEmail: "Buyer Email",
    buyerMobile: "Buyer Mobile",
    dateStr: "Date",
    BusinessName: "Shop Name",
    reason: "Reason",
    createdBy: "Created By",
    referralCode: "Referral Code"
  };
  totalNumberOfRecords: number = 0;
  salesReportData: any[] = [];
  selectionModel = new SelectionModel<any>(true, []);
  filterField = [
    {
      filterFieldName: "status",
      filterDisplayName: "Status",
      defaultValue: "",
      filterOptions: [
        { key: "Show All", value: null },
        { key: "CANCELED", value: "CANCELED" },
        { key: "EXPIRED", value: "EXPIRED" },
        { key: "FAILED", value: "FAILED" },
        { key: "NEW", value: "NEW" },
        { key: "PAID", value: "PAID" },
        { key: "REFUNDED", value: "REFUNDED" },
      ]
    },
    {
      filterFieldName: "paymentMethod",
      filterDisplayName: "Payment Method",
      defaultValue: "",
      filterOptions: [
        { key: "Show All", value: null },
        { key: paymentOptionsConstant.constantPaymentOptions.name.CREDIT_CARD, value: paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD },
        { key: paymentOptionsConstant.constantPaymentOptions.name.CASH, value: paymentOptionsConstant.constantPaymentOptions.value.CASH },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Mobile_Wallet, value: paymentOptionsConstant.constantPaymentOptions.value.Mobile_Wallet },
        { key: paymentOptionsConstant.constantPaymentOptions.name.MEEZA, value: paymentOptionsConstant.constantPaymentOptions.value.MEEZA },
        { key: paymentOptionsConstant.constantPaymentOptions.name.QASSATLY, value: paymentOptionsConstant.constantPaymentOptions.value.QASSATLY },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Free, value: paymentOptionsConstant.constantPaymentOptions.value.Free },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Fawry, value: paymentOptionsConstant.constantPaymentOptions.value.Fawry },
        { key: paymentOptionsConstant.constantPaymentOptions.name.INSTALLMENTS_6MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_6MONTHS },
        { key: paymentOptionsConstant.constantPaymentOptions.name.INSTALLMENTS_12MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_12MONTHS },
        { key: paymentOptionsConstant.constantPaymentOptions.name.INSTALLMENTS_18MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.INSTALLMENTS_18MONTHS },
        { key: paymentOptionsConstant.constantPaymentOptions.name.PaySky, value: paymentOptionsConstant.constantPaymentOptions.value.PaySky },
        { key: paymentOptionsConstant.constantPaymentOptions.name.VALU, value: paymentOptionsConstant.constantPaymentOptions.value.VALU },
        { key: paymentOptionsConstant.constantPaymentOptions.name.SOUHOOLA, value: paymentOptionsConstant.constantPaymentOptions.value.SOUHOOLA },
        { key:paymentOptionsConstant.constantPaymentOptions.name.NBE_GENERAL , value :[
            { key: paymentOptionsConstant.constantPaymentOptions.name.NBE_6MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.NBE_6MONTHS },
            { key: paymentOptionsConstant.constantPaymentOptions.name.NBE_12MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.NBE_12MONTHS },
            { key: paymentOptionsConstant.constantPaymentOptions.name.NBE_18MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.NBE_18MONTHS }
        ]},
        { key : paymentOptionsConstant.constantPaymentOptions.name.BM_GENERAL , value :[
          { key: paymentOptionsConstant.constantPaymentOptions.name.BM_6MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.BM_6MONTHS },
          { key: paymentOptionsConstant.constantPaymentOptions.name.BM_12MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.BM_12MONTHS },
          { key: paymentOptionsConstant.constantPaymentOptions.name.BM_18MONTHS, value: paymentOptionsConstant.constantPaymentOptions.value.BM_18MONTHS },
        ]},
        { key: paymentOptionsConstant.constantPaymentOptions.name.Cash_API, value: paymentOptionsConstant.constantPaymentOptions.value.Cash_API },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Installments, value: paymentOptionsConstant.constantPaymentOptions.value.Installments },
        { key: paymentOptionsConstant.constantPaymentOptions.name.OFFLINE_PAYMENT, value: paymentOptionsConstant.constantPaymentOptions.value.OFFLINE_PAYMENT },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Aman_Installments, value: paymentOptionsConstant.constantPaymentOptions.value.Aman_Installments },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Contact, value: paymentOptionsConstant.constantPaymentOptions.value.Contact },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Blnk, value: paymentOptionsConstant.constantPaymentOptions.value.Blnk },
        { key: paymentOptionsConstant.constantPaymentOptions.name.Mogo, value: paymentOptionsConstant.constantPaymentOptions.value.Mogo },
        { key: paymentOptionsConstant.constantPaymentOptions.name.HALAN, value: paymentOptionsConstant.constantPaymentOptions.value.HALAN },
        { key: paymentOptionsConstant.constantPaymentOptions.name.TRU, value: paymentOptionsConstant.constantPaymentOptions.value.TRU },
        { key: paymentOptionsConstant.constantPaymentOptions.name.APPLE_PAY, value: paymentOptionsConstant.constantPaymentOptions.value.APPLE_PAY },
        // { key: paymentOptionsConstant.constantPaymentOptions.name.INSTAPAY, value: paymentOptionsConstant.constantPaymentOptions.value.INSTAPAY },
      ]
    }
  ];
  selectionActions: SelectionAction[] = [
    {
      actionName: "Make it Failed",
      actionValue: "FAILED",
      actionType: "Button",
      actionClass: "btn-outline-danger"
    },
    {
      actionName: "Make it Paid",
      actionValue: "PAID",
      actionType: "Button",
      actionClass: "btn-primary"
    },
    {
      actionName: "Cancel Transaction",
      actionValue: "CANCELED",
      actionType: "Button",
      actionClass: "bg-white text-dark"
    }
  ];
  requestBody: Report = {};
  loading = false;
  isAssignedBusinessSelected: boolean = false
  selectableRows: CustomSelection[] = [
    {
      colName: "status",
      valueIn: ["NEW"]
    },
    {
      colName: "status",
      valueIn: ["PAID"]
    },
    {
      colName: "status",
      valueIn: ["FAILED"]
    },
    {
      colName: "status",
      valueIn: ["EXPIRED"]
    }
  ];
  rowActions: RowActions[] = [
    {
      actionName: "Resend-email",
      actionType: "icon",
      iconClass: "fa-envelope",
      actionDisableEnableField: 'status',
      actionEnableValues: ['PAID']
    },
    {
      actionName: 'Refund',
      actionType: 'icon',
      iconClass: 'fa-money-bill-transfer',
      actions: [
        {
          field: 'status',
          enabled: true,
          values: ['PAID'],
        },
        {
          field: 'paymentMethod',
          enabled: true,
          values: [
            paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD,
            paymentOptionsConstant.constantPaymentOptions.value.Mogo,
            paymentOptionsConstant.constantPaymentOptions.value.TRU,
            paymentOptionsConstant.constantPaymentOptions.value.Contact,
            paymentOptionsConstant.constantPaymentOptions.value.VALU,
            paymentOptionsConstant.constantPaymentOptions.value.SOUHOOLA,
            paymentOptionsConstant.constantPaymentOptions.value.Aman_Installments,
          ],
        },
      ],
    },
  ];

  constructor(
    public salesReportService: SalesReportService,
    private updateStatusService: UpdateStatusService,
    private resendMailOnSaleReportService: ResendMailService,
    private getSellerInfoService: GetSellerInfoService,
    private getCurrentSessionService: CurrentSessionService,
    public dialog: MatDialog,
    protected refundService: RefundCreditPaymentService,
    protected amanRefundInquiryService: AmanRefundInquiryService,
    protected translate: TranslateService,
    protected sendOTPService: ContactSendOTPService,
  ) { }

  async rowActionClicked(event: Event) {
    switch (event.action) {
      case 'Resend-email':
        await this.resendEmail(event);
        break;
      case 'Refund':
        await this.refund(event);
        break;
    }
  }

  async ngOnInit() {
    this.salesReportService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async filter(event: any) {
    //console.log("object is", event);
    if (event && Object.keys(event).length) {
      console.log("filter should not be null");
      this.requestBody.filterOptions = event;
    } else {
      console.log("filter should be null");
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.salesReportService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.salesReportService.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.salesReportService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.salesReportService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.salesReportService.activateLoader();
    if (this.requestBody['filterOptions'] && this.requestBody['filterOptions']['createdAt']) {
      // @ts-ignore
      const { startDate, endDate } = this.requestBody['filterOptions']['createdAt'];
      this.requestBody.filterOptions.createdAt.from = moment(startDate).format('YYYY-MM-DD') + " 00:00:00";
      this.requestBody.filterOptions.createdAt.to = moment(endDate).format('YYYY-MM-DD') + " 23:59:59";
    }
    if (this.isAssignedBusinessSelected){
      if(!this.requestBody['filterOptions']){
        this.requestBody['filterOptions'] = {}
      }
      const adminId =(await this.getCurrentSessionService.make())?.data?.userId;
      this.requestBody['filterOptions']['adminId'] = adminId
    } else {
      delete this.requestBody?.filterOptions?.adminId
    }
    this.salesReportService.setParams(this.requestBody);
    const report = await this.salesReportService.make();
    this.salesReportData = report.result.map((p: any) => {
      if ((!p.productName || p.productName == "") && p.paymentMethod != "Cash Api") {
        if (p.ProductType == "Quick Qassatly") {
          p.productName = `Quick Qassatly ${p.amount}`
        } else {
          p.productName = `Quick Payment ${p.amount}`;
        }
      }
      if (p.paymentMethod == "Cash Api" && (!p.productName || p.productName == "")) {
        p.productName = `Cash Api ${p.amount}`;
      }
      if (p.paymentMethod == 'cash') p.paymentMethod = paymentOptionsConstant.constantPaymentOptions.name.CASH;
      p.dateStr = moment(p.dateStr).add(2,'hours').format('MMMM D YYYY, hh:mm A')
      return p;
    });
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async selectionActionsCB(event: any) {
    // console.log(event.selection.map(i => i.paId));
    try {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: `The action you have chosen is irreversible.
         Are you sure you want to proceed?`,
          question: true
        }
      });
      const r = await dialogRef.afterClosed().toPromise();
      if (!r) {
        return;
      }
      this.updateStatusService.setParams({
        idList: event.selection.map((i: any) => i.paId),
        newStatus: event.action,
        paymentMethods: event.selection.map((i: any) => i.paymentMethod),
        merchantRefNumbers: event.selection.map((i: any) => i.merchantRefNumber),
      });
      await this.updateStatusService.make();
      this.selectionModel.clear();
      this.updateTable();
      this.salesReportService.loader().subscribe(val => (this.loading = val));
    } catch (err) {
      console.log(err);
    }
  }

  assignedBusinessesFilterChanged(value){
    this.isAssignedBusinessSelected = value;
  }

  private async resendEmail(event: Event) {
    const productName = { value: event.key.productName };
    const buyerContactInfo = {
      buyer_email: event.key.buyerEmail,
      buyer_phone: event.key.buyerMobile,
      buyer_name: event.key.buyerName
    }
    this.getSellerInfoService.setParams({ refNum: event.key.merchantRefNumber });
    const obj = await this.getSellerInfoService.make();

    this.resendMailOnSaleReportService.setParams({ trxRefNum: event.key.refNumber, productName, obj, buyerContactInfo });
    await this.resendMailOnSaleReportService.make();
  }

  private async refund(event: Event) {
    try {
      const data = event.key;
      if (
        !paymentOptionsConstant.refundPaymentOtions.includes(
          data.paymentMethod,
        )
      ) {
        await Swal.fire({
          icon: 'error',
          title: this.translate.instant('FORM_TEMPLATE.ERROR_TITLE'),
          text: this.translate.instant('FORMS.VALIDATION.IVALID', {
            field: this.translate.instant('Sellers.Products.PaymentMethod'),
          }),
        });
        return;
      }

      const isOTP = await this.refundOTP(data.paymentMethod, data.merchantRefNumber);


      await Swal.fire({
        title: this.translate.instant('PROVIDER.CREDIT.REFUNDWARNING'),
        text: isOTP ? "Buyer OTP!" : "",
        input: isOTP ? "text" : undefined,
        showCancelButton: true,
        confirmButtonText: this.translate.instant('Sellers.Products.Change'),
        showLoaderOnConfirm: true,
        preConfirm: async (otp: string) => {
          await this.callRefundService(data.merchantRefNumber, otp);
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } catch (error) {
      console.log({ error });
    }
  }

  private async callRefundService(refNum: string, otp?: string) {
    try {
      this.refundService.setParams({ refNum, otp });
      await this.refundService.make();
      await Swal.fire({
        icon: 'success',
        title: this.translate.instant('FORM_TEMPLATE.SUCCESS_TITLE'),
        text: this.translate.instant('Sellers.Products.Done'),
      });
    } catch (err) {
      const massage = err.faultyRequest.error?.message;
      await Swal.fire({
        icon: 'error',
        title: this.translate.instant('FORM_TEMPLATE.ERROR_TITLE'),
        text: massage ?? err.faultyRequest.error.error,
      });
    }
  }

  private async refundOTP(paymentMethod: string, merchantRefNumber: string) {
    try {
      switch (paymentMethod) {
        case paymentOptionsConstant.constantPaymentOptions.name
          .Aman_Installments:
          this.amanRefundInquiryService.setParams({
            trxRef: merchantRefNumber,
          });
          await this.amanRefundInquiryService.make();
          return true;
        case paymentOptionsConstant.constantPaymentOptions.name.Contact:
          this.sendOTPService.setParams({
            justSendOTP: true,
            refNum: merchantRefNumber,
          });
          await this.sendOTPService.make();
          return true;
      }

      return false;
    } catch (err) {
      const massage = err.faultyRequest.error?.message;
      await Swal.fire({
        icon: 'error',
        title: this.translate.instant('FORM_TEMPLATE.ERROR_TITLE'),
        text: massage ?? err.faultyRequest.error.error,
      });
      return false;
    }
  }
}

type Event = {
  action: "Refund" | "Resend-email" | string;
  key: SalesRow;
};

type SalesRow = {
  BusinessName: string;
  BusinessId: number;
  Quantity: number;
  amount: string;
  buyerEmail: string;
  buyerMobile: string;
  buyerName: string;
  createdBy: string;
  date: string;
  dateStr: string;
  merchantRefNumber: string;
  paId: number;
  paymentMethod: string;
  prId: number;
  productName: string;
  productType: string;
  promocodeTitle: string;
  reason: string;
  refNumber: string;
  status: string;
  adminId: number;
  code: string;
};
